import { Button } from 'blaze-ui/Button'
import Styles from './PostPreviewBody.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import AlertTriangle from 'blaze-ui/icons/20/AlertTriangle'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import cx from 'classnames'

interface ErrorProps {
  errorMessages: string[]
  smallLayout?: boolean
  action?: {
    label: string
    onPress: () => void
  }
  actions?: {
    label: string
    icon: React.FC
    onPress: () => void
  }[]
}

export const sanitizeErrorMessage = (errorMessage: string) => {
  const isMediaFormatError = errorMessage.includes('2207026')

  if (isMediaFormatError)
    return 'There was an issue with the media file used for this post. Please ensure the media file meets all platform requirements'
  return errorMessage
}

export const Error = ({ errorMessages, action, actions, smallLayout }: ErrorProps) => {
  const { isMobile } = useResponsiveDesign()
  const isSmallLayout = isMobile || smallLayout

  const renderActions = () => (
    <>
      {actions && (
        <div className={Styles.actionsContainer}>
          {actions.map((action) => (
            <Button size="sm" onPress={action.onPress} variant="secondary" key={action.label} frontIcon={action.icon}>
              {action.label}
            </Button>
          ))}
        </div>
      )}
      {action && (
        <div className={Styles.actionsContainer}>
          <Button
            fullWidth={isSmallLayout}
            size={isSmallLayout ? 'md' : 'sm'}
            onPress={action.onPress}
            variant="secondary"
          >
            {action.label}
          </Button>
        </div>
      )}
    </>
  )

  if (errorMessages.length > 1) {
    return (
      <div className={cx(Styles.error, Styles.multiple, { [Styles.isSmallLayout]: isSmallLayout })}>
        <div className={Styles.header}>
          <div className={Styles.left}>
            <AlertTriangle />
            <Text variant="largeList" color="var(--negative-60">
              Your post has multiple issues:
            </Text>
          </div>
          {!isSmallLayout && renderActions()}
        </div>
        <div className={Styles.errorsContainer}>
          {errorMessages.map((errorMessage, index) => (
            <div className={Styles.errorMessage} key={errorMessage}>
              <Text variant="placeholder" color="var(--negative-60">
                {index + 1}. {sanitizeErrorMessage(errorMessage)}
              </Text>
            </div>
          ))}
        </div>
        {isSmallLayout && renderActions()}
      </div>
    )
  }

  return (
    <div className={cx(Styles.error, { [Styles.isSmallLayout]: isSmallLayout })}>
      <div className={cx(Styles.left, { [Styles.justifyCenter]: !isSmallLayout })}>
        <AlertTriangle />
        <Text variant="largeList" color="var(--negative-60">
          {sanitizeErrorMessage(errorMessages[0])}
        </Text>
      </div>
      {renderActions()}
    </div>
  )
}
